import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const NoTariffPage = () => {
  return (
    <>
      <Helmet>
        <title>Не найдено</title>
      </Helmet>
      <div className="tw-container tw-mx-auto">
        <div className="tw-flex tw-justify-center">
          <div className="tw-w-full">
            <div className="tw-min-h-screen tw-flex tw-items-center tw-justify-center">
              <div className="tw-text-center">
                <img src="/img/svg/404.svg" alt="404" className="tw-mx-auto" />
                <div className="tw-text-6xl tw-font-bold tw-mt-6">404</div>
                <h5 className="tw-font-medium tw-text-lg tw-mt-2">
                  Ваш тариф истек или не существует. Обратитесь к менеджеру
                </h5>
                <div className="tw-flex tw-justify-center tw-mt-8">
                  <Link
                    to="/"
                    className="tw-bg-blue-600 tw-text-white tw-rounded-xl tw-px-8 tw-py-2 hover:tw-bg-blue-700 tw-transition"
                  >
                    На главную
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default NoTariffPage;
